











import { Component, Vue, Ref} from 'vue-property-decorator';
import TwoLevelDrawer from './twoLevelDrawer.vue';

@Component({
  components: {
    TwoLevelDrawer,
  },
})
export default class MenuList extends Vue {
  @Ref() private readonly twoDrawer!: TwoLevelDrawer;
  private selectMenu(menuItem: any) {
    this.twoDrawer.visible = true;
    this.twoDrawer.currentComponent = menuItem.key;
  }
}
